import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HeaderReportModel } from 'Modules'

export type HeaderReportState = {
	report: HeaderReportModel | null
}

const initialState: HeaderReportState = {
	report: null,
}

export namespace HeaderReportNS {
	export type GetHeaderReport = PayloadAction
	export type SetHeaderReport = PayloadAction<HeaderReportModel>
}

export const headerReportSlice = createSlice({
	name: 'headerReport',
	initialState,
	reducers: {
		getAll: (state, action: HeaderReportNS.GetHeaderReport) => {},
		setAll: (state, action: HeaderReportNS.SetHeaderReport) => {
			state.report = action.payload
		},
	},
})
